module.exports = __webpack_public_path__ + "static/media/create-outline.ddbbfa50.svg";